export default "__VITE_ASSET__DYHJJKe6__"